export enum MatchLocation {
    home = "home",
    away = "away",
}
